import React, { useEffect, useState } from 'react';
import {AppBar, Dialog, DialogContent, IconButton, Toolbar, Typography} from '@mui/material';
import {Button, Slide } from '@mui/material/';
import {Close, GetApp,  } from '@mui/icons-material';

//Styles
import {useStyles} from './style';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Base64Pdf(props) {
    const classes = useStyles(),
        [scroll, setScroll] = useState('paper');
        const [pdfSource, setPdfSource] = useState('');

    const convertirBase64AUrl = (pdf) => {
        if (!pdf || typeof pdf !== 'string') return '';
        if (pdf.startsWith('data:') || pdf.startsWith('blob:')) return pdf;

        const base64 = pdf.includes('base64,') ? pdf.split('base64,')[1] : pdf;

        try {
            const binary = window.atob(base64);
            const bytes = new Uint8Array(binary.length);
            for (let index = 0; index < binary.length; index += 1) {
                bytes[index] = binary.charCodeAt(index);
            }
            const blob = new Blob([bytes], { type: 'application/pdf' });
            return URL.createObjectURL(blob);
        } catch (error) {
            return `data:application/pdf;base64,${pdf}`;
        }
    };

    useEffect(() => {
        if (!props.pdf) {
            setPdfSource('');
            return;
        }

        const url = convertirBase64AUrl(props.pdf);
        setPdfSource(url);

        return () => {
            if (url.startsWith('blob:')) {
                URL.revokeObjectURL(url);
            }
        };
    }, [props.pdf]);

    const usarScroll = (scrollType) => () => {
        setScroll(scrollType)
    }
    useEffect(() => {
        if(props.open) {
            usarScroll()
        }
    },[props.open])
    return (
        <div>
            <Dialog fullScreen open={props.open} onClose={props.handleClose} TransitionComponent={Transition} scroll={scroll} aria-labelledby="scroll-dialog-title" aria-describedby="scroll-dialog-description">
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={props.handleClose} aria-label="close">
                            <Close />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>{props.title}</Typography>
                        {props.showDownloadButton && (
                            <Button startIcon={<GetApp />} edge="end" color="inherit" onClick={props.DescargarPDF}>Descargar</Button>
                        )}
                        <Button startIcon={<Close />}  edge="end" color="inherit" onClick={props.handleClose}>Cerrar</Button>
                    </Toolbar>
                </AppBar>
                <DialogContent dividers={scroll === 'paper'} className={classes.dialogContent}>
                    {pdfSource ? (
                        <iframe
                            src={pdfSource}
                            width="100%" height="100%" frameBorder="0" allowFullScreen
                        />
                    ) : null}
                </DialogContent>
            </Dialog>
        </div>
    );
}

Base64Pdf.defaultProps = {
    open: false,
    pdf: "",
    showDownloadButton : true,
    src: "/assets/simboloPdf.svg"
}
